import defaultPalette from '../palette';
export default (function (_a) {
    var _b;
    var _c = _a.palette, palette = _c === void 0 ? defaultPalette : _c;
    return {
        MuiRadio: {
            colorPrimary: {
                '&$checked': {
                    color: (_b = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _b === void 0 ? void 0 : _b.light,
                },
                '&&$disabled': {
                    color: palette === null || palette === void 0 ? void 0 : palette.grey[400],
                    '&$checked': {
                        color: palette === null || palette === void 0 ? void 0 : palette.primary[100],
                    },
                },
            },
        },
    };
});
